import {
  Box,
  Button,
  chakra,
  Heading,
  HStack,
  Image,
  // Menu,
  // MenuButton,
  // MenuGroup,
  // MenuItem,
  // MenuList,
  VStack,
} from '@chakra-ui/react';
import { t } from 'i18next';
// import { useState } from 'react';
import { OrganizationAppSubscription } from '~components/displays/BulkAction/BulkManageApps';
import {
  // ChevronDownIcon,
  // ChevronUpIcon,
  GridIcon,
  TrashIcon,
} from '~components/ui/icons';
import { ConfigApp } from './apps/ConfigApps';

export function ContentAppEntry({
  subscription,
  // version,
  onDelete,
  onInstall,
  unavailabilityReason,
  disabled = false,
}: {
  subscription: ConfigApp | OrganizationAppSubscription;
  // version?: string;
  onDelete?: () => void;
  onInstall?: () => void;
  unavailabilityReason?: string;
  disabled?: boolean;
}) {
  // const [selectedVersion, setSelectedVersion] = useState<string | undefined>(
  //   version ?? subscription.appVersions?.[0],
  // );
  // const [versionToggleOpened, setVersionToggleOpened] = useState(false);

  // const handleVersionToggleButtonClick = () => {
  //   setVersionToggleOpened(!versionToggleOpened);
  // };

  return (
    <HStack spacing={3} justifyContent="center" width="100%">
      <Box
        borderRadius="base"
        border="1px solid"
        borderColor="gray.100"
        overflow="hidden"
        opacity={disabled ? '0.5' : undefined}
      >
        {subscription.iconUrl ? (
          <Image
            width="48px"
            height="48px"
            src={subscription.iconUrl}
            alt={`App icon for ${subscription.name}`}
          />
        ) : (
          <Box
            display="flex"
            width="48px"
            height="48px"
            justifyContent="center"
            alignItems="center"
          >
            <GridIcon color="gray.500" width={4} height={4} />
          </Box>
        )}
      </Box>
      <VStack alignItems="flex-start" spacing={0} flex={1}>
        <VStack alignItems="flex-start" spacing={0}>
          <HStack spacing={3} alignItems="center">
            <Heading
              size="md"
              color="gray.900"
              mb="0"
              lineHeight="7"
              opacity={disabled ? '0.5' : undefined}
            >
              {subscription.name}
            </Heading>
          </HStack>
          {/* {onInstall !== undefined &&
            subscription.appVersions &&
            subscription.appVersions.length > 0 && (
              <Menu isOpen={versionToggleOpened}>
                <MenuButton onClick={handleVersionToggleButtonClick} color="gray.500">
                  {selectedVersion}
                  {versionToggleOpened ? <ChevronUpIcon /> : <ChevronDownIcon />}
                </MenuButton>
                <MenuList>
                  <MenuGroup
                    title="Latest version"
                    color="gray.400"
                    fontSize="sm"
                    px="3"
                    py="1.5"
                    m="0"
                  >
                    <MenuItem
                      onClick={() => {
                        setSelectedVersion(subscription.appVersions?.[0] ?? selectedVersion);
                        setVersionToggleOpened(false);
                      }}
                      fontWeight="bold"
                      color="gray.900"
                      backgroundColor={
                        selectedVersion === subscription.appVersions?.[0] ? 'blue.50' : undefined
                      }
                      _hover={{ backgroundColor: 'gray.100' }}
                    >
                      {subscription.appVersions[0]}
                    </MenuItem>
                  </MenuGroup>
                  {subscription.appVersions.length > 1 && (
                    <MenuGroup
                      title="Older versions"
                      color="gray.400"
                      fontSize="sm"
                      px="3"
                      py="1.5"
                      m="0"
                    >
                      {subscription.appVersions.slice(1).map((version) => (
                        <MenuItem
                          key={version}
                          onClick={() => {
                            setSelectedVersion(version);
                            setVersionToggleOpened(false);
                          }}
                          fontWeight="bold"
                          color="gray.900"
                          backgroundColor={selectedVersion === version ? 'blue.50' : undefined}
                          _hover={{ backgroundColor: 'gray.100' }}
                        >
                          {version}
                        </MenuItem>
                      ))}
                    </MenuGroup>
                  )}
                </MenuList>
              </Menu>
            )}
          {onDelete !== undefined && (
            <chakra.span color="gray.500" opacity={disabled ? '0.5' : undefined}>
              {version ?? version ?? <span>&nbsp;</span>}
            </chakra.span>
          )} */}
        </VStack>
      </VStack>
      <Box>
        {onInstall !== undefined && (
          <Button
            size="sm"
            variant="outline"
            colorScheme="blue"
            onClick={() => onInstall()}
            isDisabled={disabled}
          >
            {t('add')}
          </Button>
        )}
        {onDelete !== undefined && (
          <Button
            size="sm"
            variant="inline"
            colorScheme="gray"
            onClick={onDelete}
            isDisabled={disabled}
          >
            <TrashIcon color="gray.300" width="actionIconSize" height="actionIconSize" />
          </Button>
        )}
        {unavailabilityReason !== undefined && unavailabilityReason !== '' && (
          <chakra.span color="gray.500">{unavailabilityReason}</chakra.span>
        )}
      </Box>
    </HStack>
  );
}
